module.exports = __webpack_public_path__ + "img/Liputan-Image.0f690461.png";